<template>
    <div class="service-list-product u-reset" :class="rootClasses">
        <div class="service-list-product--row">
            <a :href="link" class="service-list-product--col service-list-product--figure-link u-reset">
                <figure class="service-list-product--figure">
                    <img class="service-list-product--image" :src="image">
                </figure>
            </a>
            <div class="service-list-product--info service-list-product--col">
                <a :href="link" class="service-list-product--info-link u-reset">
                    <h3 class="service-list-product--title u-reset">{{ title }}</h3>
                    <p class="service-list-product--description">{{ description }}</p>
                </a>
                <ul class="service-list-product--tag-list u-reset">
                    <li class="service-list-product--tag"
                            v-for="(tag, index) in tags"
                            :id="'tag-' + tag.id"
                            :key="index">
                        <a :href="generateTagLink(tag)" class="service-list-product--tag-text u-reset">
                            {{ tag.title }}
                        </a>
                    </li>
                </ul>
            </div>
            <a class="service-list-product--icon service-list-product--col u-reset" :href="link" v-if="hasArrow">
                <ui-icon symbol="arrow-right" size="medium"/>
            </a>
        </div>
    </div>
</template>

<script>
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';
    import UiIcon from '@dreipol/vue-ui/src/components/icon/icon.vue';

    export default {
        components: {
            UiIcon,
        },
        mixins: [bemMixin('service-list-product')],
        props: {
            title: {
                type: String,
                required: true,
            },
            tags: {
                type: Array,
                default: () => [],
            },
            link: {
                type: String,
                required: true,
            },
            description: {
                type: String,
                default: '',
                required: false,
            },
            id: {
                type: Number,
                required: true,
            },
            image: {
                type: String,
                required: true,
            },
            hasArrow: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            rootClasses() {
                // return this.hasArrow ? 'has-arrow' : 'base';
                return [
                    this.bemIf(this.hasArrow, 'has-arrow', 'base'),
                ];
            },
        },
        methods: {
            generateTagLink(tag) {
                return `${ window.location.pathname }?query=${ encodeURIComponent(tag.title) }`;
            },
        },
    };
</script>
